module.exports = __webpack_public_path__ + "img/32-heat-exhaustion-fr.1f27f070.svg";